import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setSubscribeStatus('Please enter your email');
      return;
    }

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6ajjhdbd17lru29lsdg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubscribeStatus('Thank you for subscribing!');
        setEmail('');
        setTimeout(() => setSubscribeStatus(''), 3000);
      } else {
        setSubscribeStatus('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubscribeStatus('Error subscribing. Please try again.');
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-slate-900 text-white pt-20 pb-10">
      <div className="max-w-[1200px] mx-auto px-20">
        <div className="grid grid-cols-12 gap-16 mb-16">
          <div className="col-span-5">
            <h3 className="text-3xl font-light mb-4">Stay Informed</h3>
            <p className="text-slate-400 mb-10 text-sm">
              Get insights on AI strategy and intelligent transformation.
            </p>
            <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="space-y-5">
              <div className="border-b border-white/30 pb-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="w-full bg-transparent text-white placeholder-slate-400 focus:outline-none"
                  required
                />
              </div>
              {subscribeStatus && (
                <p className={`text-sm ${subscribeStatus.includes('Thank you') ? 'text-green-400' : 'text-red-400'}`}>
                  {subscribeStatus}
                </p>
              )}
              <button
                type="submit"
                className="px-8 py-3 bg-white text-slate-900 rounded-full hover:bg-slate-100 transition-all duration-200 flex items-center gap-2 font-medium cursor-pointer whitespace-nowrap"
              >
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div className="col-span-3">
            <h4 className="text-sm font-medium text-slate-400 mb-6">Navigate</h4>
            <div className="space-y-4">
              <button onClick={() => scrollToSection('approach')} className="block text-white hover:text-sky-400 transition-colors cursor-pointer whitespace-nowrap">
                Our Approach
              </button>
              <button onClick={() => scrollToSection('industries')} className="block text-white hover:text-sky-400 transition-colors cursor-pointer whitespace-nowrap">
                Industries
              </button>
              <button onClick={() => scrollToSection('differentiation')} className="block text-white hover:text-sky-400 transition-colors cursor-pointer whitespace-nowrap">
                Why Us
              </button>
              <button onClick={() => scrollToSection('final-cta')} className="block text-white hover:text-sky-400 transition-colors cursor-pointer whitespace-nowrap">
                Contact
              </button>
            </div>
          </div>

          <div className="col-span-4">
            <h4 className="text-sm font-medium text-slate-400 mb-6">Connect</h4>
            <div className="space-y-3 mb-8">
              <p className="text-white">contact@northstarinnovations.ai</p>
              <p className="text-white">+1 (555) 123-4567</p>
            </div>
            <h4 className="text-sm font-medium text-slate-400 mb-4">Visit</h4>
            <p className="text-slate-300 text-sm leading-relaxed">
              123 Innovation Drive<br />
              San Francisco, CA 94105
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                LinkedIn
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Twitter
              </a>
            </div>

            <p className="text-slate-400 text-sm">
              © 2025 NorthStar Innovations AI. All rights reserved.
            </p>

            <div className="flex items-center gap-6">
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Privacy
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
